import React from "react";
import Seo, { breadcrumbJsonLd } from "@/components/Seo";
import PageHero from "@/components/ui-kit/PageHero";
import { Container, Section } from "@/components/ui-kit/Section";

export function LegalBlock({ heading, id, children }) {
  return (
    <section id={id}>
      <h2 className="font-display text-2xl font-bold tracking-tight text-etap-deep-900">{heading}</h2>
      <div className="mt-3 space-y-3 leading-relaxed text-etap-deep-600">{children}</div>
    </section>
  );
}

export default function LegalLayout({ title, seoTitle, description, path, lastUpdated, intro, children }) {
  return (
    <>
      <Seo
        title={seoTitle}
        description={description}
        path={path}
        jsonLd={[
          breadcrumbJsonLd([
            { name: "Home", path: "/" },
            { name: title, path },
          ]),
        ]}
      />
      <PageHero eyebrow="Legal" title={title} subtitle={intro} />
      <Section className="bg-canvas pt-4">
        <Container>
          <div className="mx-auto max-w-3xl">
            <p className="mb-8 text-sm font-semibold text-etap-deep-500">Last updated: {lastUpdated}</p>
            <div className="space-y-10">{children}</div>
            <div className="mt-12 rounded-2xl border border-etap-mint-300 bg-etap-mint-100 p-5 text-sm text-etap-deep-700">
              This page is a structured template with placeholder sections for counsel approved copy. ETAP does not
              provide tax, legal, or accounting advice.
            </div>
          </div>
        </Container>
      </Section>
    </>
  );
}
